module.exports = __webpack_public_path__ + "static/img/logo_oos.f095009.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_oos.png
// module id = SlZj
// module chunks = 46